export class UploadDocumentModel{
MediaName:string;
ContentType:string;
MediaContent:string;
    IsSavedImage: boolean;
    MediaIndex: number;
}